import React, { useState, useEffect, useRef } from 'react';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAppId } from "../context/AppIdContext";
import '../style/adminList.css';
import Header from '../component/header';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const Volunteers = () => {
    const { appId, userId, language, userName } = useAppId();

    const lang = language || 'en';

    // Generate WhatsApp message in Gujarati for Volunteer
    const generateWhatsAppMessage = (volunteerName) => {
        const loginUserName = userName || 'Admin';
        return `નમસ્તે ${volunteerName}, ${loginUserName} એ તમને કાર્યકર્તા જવાબદારી સોંપેલી છે.`;
    };

    // Generate SMS message in Gujarati for Volunteer
    const generateSMSMessage = (volunteerName) => {
        const loginUserName = userName || 'Admin';
        return `નમસ્તે ${volunteerName}, ${loginUserName} એ તમને કાર્યકર્તા જવાબદારી સોંપેલી છે.`;
    };

    // Translation dictionary
    const t = {
        en: {
            title: "Volunteers",
            subtitle: "Manage platform volunteers and their activities.",
            addBtn: "Add Volunteer",
            cancelBtn: "Cancel",
            submitBtn: "Add Volunteer",
            addingBtn: "Adding...",
            updateBtn: "Update Volunteer",
            updatingBtn: "Updating...",
            viewProfile: "View Profile",
            addModalTitle: "Add New Volunteer",
            editModalTitle: "Edit Volunteer",
            nameLabel: "Full Name",
            mobileLabel: "Mobile Number",
            fillAllFields: "Please fill in all fields",
            validMobile: "Please enter a valid 10-digit mobile number",
            mobileRequired: "Mobile number is required",
            mobileLength: "Mobile number must be 10 digits",
            mobileNumeric: "Mobile number must contain only digits",
            mobileInvalid: "Please enter a valid Indian mobile number (starts with 6,7,8,9)",
            addSuccess: "Volunteer added successfully!",
            updateSuccess: "Volunteer updated successfully!",
            invalidMobile: "Invalid mobile no",
            searchPlaceholder: "Search by name or mobile...",
            noRecordsFound: "No volunteers found matching",
            loading: "Loading Data...",
            sendWhatsapp: "Send Responsibility in Whatsapp",
            sendSMS: "Send Responsibility in SMS",
            active: "ACTIVE",
            notActive: "NOT ACTIVE",
            error: "Error",
            failed: "Failed: ",
            addError: "Error adding volunteer.",
            updateError: "Error updating volunteer",
            deleteConfirm: "Are you sure you want to delete this volunteer?",
            deleteSuccess: "Volunteer deleted successfully!",
            deleteFailed: "Failed to delete volunteer.",
            deleteError: "Error deleting volunteer.",
            userIdMissing: "Error: User ID is missing."
        },
        hi: {
            title: "कार्यकर्ता",
            subtitle: "प्लेटफॉर्म कार्यकर्ता और उनकी गतिविधियों का प्रबंधन करें।",
            addBtn: "कार्यकर्ता जोड़ें",
            cancelBtn: "रद्द करें",
            submitBtn: "कार्यकर्ता जोड़ें",
            addingBtn: "जोड़ा जा रहा है...",
            updateBtn: "कार्यकर्ता अपडेट करें",
            updatingBtn: "अपडेट किया जा रहा है...",
            viewProfile: "प्रोफाइल देखें",
            addModalTitle: "नया कार्यकर्ता जोड़ें",
            editModalTitle: "कार्यकर्ता संपादित करें",
            nameLabel: "पूरा नाम",
            mobileLabel: "मोबाइल नंबर",
            fillAllFields: "कृपया सभी फ़ील्ड भरें",
            validMobile: "कृपया 10 अंकों का मोबाइल नंबर दर्ज करें।",
            mobileRequired: "मोबाइल नंबर आवश्यक है",
            mobileLength: "मोबाइल नंबर 10 अंकों का होना चाहिए",
            mobileNumeric: "मोबाइल नंबर में केवल अंक होने चाहिए",
            mobileInvalid: "कृपया एक वैध भारतीय मोबाइल नंबर दर्ज करें (6,7,8,9 से शुरू)",
            addSuccess: "कार्यकर्ता सफलतापूर्वक जोड़ा गया!",
            updateSuccess: "कार्यकर्ता सफलतापूर्वक अपडेट किया गया!",
            invalidMobile: "अमान्य मोबाइल नंबर",
            searchPlaceholder: "नाम या मोबाइल से खोजें...",
            noRecordsFound: "कोई कार्यकर्ता नहीं मिला",
            loading: "डेटा लोड हो रहा है...",
            sendWhatsapp: "व्हाट्सएप पर जिम्मेदारी भेजें",
            sendSMS: "एसएमएस पर जिम्मेदारी भेजें",
            active: "सक्रिय",
            notActive: "निष्क्रिय",
            error: "त्रुटि",
            failed: "विफल: ",
            addError: "कार्यकर्ता जोड़ने में त्रुटि।",
            updateError: "कार्यकर्ता अपडेट करने में त्रुटि",
            deleteConfirm: "क्या आप वाकई इस कार्यकर्ता को हटाना चाहते हैं?",
            deleteSuccess: "कार्यकर्ता सफलतापूर्वक हटा दिया गया!",
            deleteFailed: "कार्यकर्ता को हटाने में विफल।",
            deleteError: "कार्यकर्ता को हटाने में त्रुटि।",
            userIdMissing: "त्रुटि: उपयोगकर्ता आईडी गायब है।"
        },
        gu: {
            title: "કાર્યકર્તા",
            subtitle: "પ્લેટફોર્મ કાર્યકર્તા અને તેમની પ્રવૃત્તિઓનું સંચાલન કરો.",
            addBtn: "કાર્યકર્તા ઉમેરો",
            cancelBtn: "રદ કરો",
            submitBtn: "કાર્યકર્તા ઉમેરો",
            addingBtn: "ઉમેરાઈ રહ્યું છે...",
            updateBtn: "કાર્યકર્તા અપડેટ કરો",
            updatingBtn: "અપડેટ થઈ રહ્યું છે...",
            viewProfile: "પ્રોફાઇલ જુઓ",
            addModalTitle: "નવો કાર્યકર્તા ઉમેરો",
            editModalTitle: "કાર્યકર્તા સંપાદિત કરો",
            nameLabel: "પૂરું નામ",
            mobileLabel: "મોબાઇલ નંબર",
            fillAllFields: "કૃપા કરીને બધા ફીલ્ડ ભરો",
            validMobile: "કૃપા કરીને 10 અંકનો માન્ય મોબાઇલ નંબર દાખલ કરો.",
            mobileRequired: "મોબાઇલ નંબર જરૂરી છે",
            mobileLength: "મોબાઇલ નંબર 10 અંકનો હોવો જોઈએ",
            mobileNumeric: "મોબાઇલ નંબરમાં માત્ર અંકો હોવા જોઈએ",
            mobileInvalid: "કૃપા કરીને માન્ય ભારતીય મોબાઇલ નંબર દાખલ કરો (6,7,8,9 થી શરૂ)",
            addSuccess: "કાર્યકર્તા સફળતાપૂર્વક ઉમેરાયો!",
            updateSuccess: "કાર્યકર્તા સફળતાપૂર્વક અપડેટ થયો!",
            invalidMobile: "અમાન્ય મોબાઇલ નંબર",
            searchPlaceholder: "નામ અથવા મોબાઇલથી શોધો...",
            noRecordsFound: "કોઈ કાર્યકર્તા મળ્યો નથી",
            loading: "ડેટા લોડ થઈ રહ્યો છે...",
            sendWhatsapp: "વોટ્સએપમાં જવાબદારી મોકલો",
            sendSMS: "એસએમએસમાં જવાબદારી મોકલો",
            active: "સક્રિય",
            notActive: "નિષ્ક્રિય",
            error: "ભૂલ",
            failed: "નિષ્ફળ: ",
            addError: "કાર્યકર્તા ઉમેરવામાં ભૂલ.",
            updateError: "કાર્યકર્તા અપડેટ કરવામાં ભૂલ",
            deleteConfirm: "શું તમે ખરેખર આ કાર્યકર્તાને કાઢી નાખવા માંગો છો?",
            deleteSuccess: "કાર્યકર્તા સફળતાપૂર્વક કાઢી નાખવામાં આવ્યો!",
            deleteFailed: "કાર્યકર્તા કાઢી નાખવામાં નિષ્ફળ.",
            deleteError: "કાર્યકર્તા કાઢી નાખવામાં ભૂલ.",
            userIdMissing: "ભૂલ: વપરાશકર્તા ID ગુમ થયેલ છે."
        }
    };

    const txt = t[lang] || t['en'];

    // --- Logic State ---
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    // --- Mobile Search State ---
    const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);

    // --- Add Volunteer State ---
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({ name: '', mobile_no: '' });
    const [mobileError, setMobileError] = useState("");

    // --- Edit Volunteer State ---
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editFormData, setEditFormData] = useState({ user_id: '', name: '', mobile_no: '' });
    const [editMobileError, setEditMobileError] = useState("");

    // --- Profile Detail Modal State & Photo Upload State ---
    const [selectedUser, setSelectedUser] = useState(null);
    const fileInputRef = useRef(null);
    const [isUploadingPhoto, setIsUploadingPhoto] = useState(false);

    // Mobile number validation function
    const validateMobileNumber = (number) => {
        if (!number) {
            return { isValid: false, message: txt.mobileRequired };
        }
        if (!/^\d{10}$/.test(number)) {
            return { isValid: false, message: txt.mobileLength };
        }
        if (!/^\d+$/.test(number)) {
            return { isValid: false, message: txt.mobileNumeric };
        }
        const firstDigit = number.charAt(0);
        if (!['6', '7', '8', '9'].includes(firstDigit)) {
            return { isValid: false, message: txt.mobileInvalid };
        }
        return { isValid: true, message: "" };
    };

    // --- API Fetching ---
    useEffect(() => {
        if (appId) { fetchUsers(); }
    }, [appId]);

    const fetchUsers = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`${BASE_URL}/api/display_karyakarta`, { app_id: appId });
            if (response.data.success && response.data.data && response.data.data.result) {
                setUsers(response.data.data.result);
            } else {
                setUsers([]);
            }
        } catch (err) {
            console.error("API Error:", err);
            setUsers([]);
        } finally {
            setLoading(false);
        }
    };

    // --- Profile Photo Update Handler ---
    const handlePhotoChange = async (event) => {
        const file = event.target.files[0];
        if (!file || !selectedUser) return;

        setIsUploadingPhoto(true);

        try {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (e) => {
                const img = new Image();
                img.onload = async () => {
                    const canvas = document.createElement('canvas');

                    // Max dimensions to keep base64 under server limits
                    const MAX_WIDTH = 800;
                    const MAX_HEIGHT = 800;
                    let width = img.width;
                    let height = img.height;

                    // Calculate aspect ratio
                    if (width > height) {
                        if (width > MAX_WIDTH) {
                            height *= MAX_WIDTH / width;
                            width = MAX_WIDTH;
                        }
                    } else {
                        if (height > MAX_HEIGHT) {
                            width *= MAX_HEIGHT / height;
                            height = MAX_HEIGHT;
                        }
                    }

                    canvas.width = width;
                    canvas.height = height;

                    const ctx = canvas.getContext('2d');
                    ctx.fillStyle = "#FFFFFF";
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                    ctx.drawImage(img, 0, 0, width, height);

                    // Compress to JPEG format with 0.7 quality
                    const dataUrl = canvas.toDataURL('image/jpeg', 0.7);
                    const pureBase64 = dataUrl.split(',')[1];

                    // Format filename
                    let fileName = file.name;
                    const lastDotIndex = fileName.lastIndexOf('.');
                    if (lastDotIndex !== -1) {
                        fileName = fileName.substring(0, lastDotIndex) + ".jpg";
                    } else {
                        fileName = fileName + ".jpg";
                    }

                    const payload = {
                        user_id: (selectedUser.user_id || selectedUser.id),
                        photo: fileName,
                        base64: pureBase64
                    };

                    try {
                        const response = await axios.post(`${BASE_URL}/api/change_profile_photo`, payload);

                        if (response.data.success || response.data.Success === "1" || (response.data.data && response.data.data.Success === "1")) {
                            alert("Profile photo updated successfully!");
                            fetchUsers();
                            setSelectedUser({ ...selectedUser, photo: dataUrl, photo_path: dataUrl });
                        } else {
                            alert("Failed to update profile photo.");
                        }
                    } catch (error) {
                        console.error("Error uploading photo:", error);
                        if (error.response && error.response.status === 413) {
                            alert("Image is still too large after compression. Please select a smaller photo.");
                        } else {
                            alert("Error updating profile photo.");
                        }
                    } finally {
                        setIsUploadingPhoto(false);
                    }
                };
                img.onerror = () => {
                    alert("Error processing image.");
                    setIsUploadingPhoto(false);
                };
                img.src = e.target.result;
            };
            reader.onerror = () => {
                alert("Error reading file.");
                setIsUploadingPhoto(false);
            };
        } catch (error) {
            console.error("Setup Error:", error);
            setIsUploadingPhoto(false);
        } finally {
            if (fileInputRef.current) fileInputRef.current.value = '';
        }
    };

    // --- Handlers ---
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'mobile_no') {
            const numericValue = value.replace(/[^0-9]/g, '');
            const limitedValue = numericValue.slice(0, 10);
            setFormData(prev => ({ ...prev, [name]: limitedValue }));

            if (mobileError) setMobileError("");

            if (limitedValue.length === 10) {
                const validation = validateMobileNumber(limitedValue);
                if (!validation.isValid) {
                    setMobileError(validation.message);
                } else {
                    setMobileError("");
                }
            } else if (limitedValue.length > 0 && limitedValue.length < 10) {
                setMobileError(txt.mobileLength);
            }
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleAddVolunteer = async (e) => {
        e.preventDefault();
        if (!formData.name || !formData.mobile_no) {
            alert(txt.fillAllFields);
            return;
        }

        const validation = validateMobileNumber(formData.mobile_no);
        if (!validation.isValid) {
            alert(validation.message);
            setMobileError(validation.message);
            return;
        }

        setIsSubmitting(true);
        const payload = {
            app_id: appId,
            name: formData.name,
            mobile_no: formData.mobile_no,
            user_type: "k",
            booth_no: "0",
            booth_list: "",
            create_by: userId
        };

        try {
            const response = await axios.post(`${BASE_URL}/api/insert_user`, payload);
            if (response.data.success && response.data.data && response.data.data.Success == "1") {
                alert(txt.addSuccess);
                setIsModalOpen(false);
                setFormData({ name: '', mobile_no: '' });
                setMobileError("");
                fetchUsers();
            } else {
                alert("Mobile number already exists.");
            }
        } catch (error) {
            console.error("❌ Axios Error:", error);
            alert(txt.addError);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleEditClick = () => {
        if (selectedUser) {
            setEditFormData({
                user_id: selectedUser.user_id,
                name: selectedUser.name,
                mobile_no: selectedUser.mobile_no
            });
            setEditMobileError("");
            setSelectedUser(null);
            setIsEditModalOpen(true);
        }
    };

    const handleEditInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'mobile_no') {
            const numericValue = value.replace(/[^0-9]/g, '');
            const limitedValue = numericValue.slice(0, 10);
            setEditFormData(prev => ({ ...prev, [name]: limitedValue }));

            if (editMobileError) setEditMobileError("");

            if (limitedValue.length === 10) {
                const validation = validateMobileNumber(limitedValue);
                if (!validation.isValid) {
                    setEditMobileError(validation.message);
                } else {
                    setEditMobileError("");
                }
            } else if (limitedValue.length > 0 && limitedValue.length < 10) {
                setEditMobileError(txt.mobileLength);
            }
        } else {
            setEditFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleUpdateVolunteer = async (e) => {
        e.preventDefault();
        if (!editFormData.name || !editFormData.mobile_no) {
            alert(txt.fillAllFields);
            return;
        }

        const validation = validateMobileNumber(editFormData.mobile_no);
        if (!validation.isValid) {
            alert(validation.message);
            setEditMobileError(validation.message);
            return;
        }

        setIsEditing(true);

        const payload = {
            user_id: editFormData.user_id,
            app_id: appId,
            name: editFormData.name,
            mobile_no: editFormData.mobile_no,
            user_type: "k",
            booth_no: "0",
            booth_list: "",
            create_by: userId
        };

        try {
            const response = await axios.post(`${BASE_URL}/api/update_user`, payload);
            if (response.data.success && response.data.data && response.data.data.Success == "1") {
                alert(txt.updateSuccess);
                setIsEditModalOpen(false);
                setEditMobileError("");
                fetchUsers();
            } else {
                alert(response.data.data?.Message || txt.invalidMobile);
            }
        } catch (error) {
            console.error("Axios Error:", error);
            alert(txt.updateError);
        } finally {
            setIsEditing(false);
        }
    };

    // --- Delete Handler ---
    const handleDeleteAdmin = async (id) => {
        if (!id) {
            alert(txt.userIdMissing);
            return;
        }

        if (window.confirm(txt.deleteConfirm)) {
            try {
                const response = await axios.post(`${BASE_URL}/api/dlt_user`, {
                    app_id: appId,
                    user_id: id,
                    delete_by: userId
                });

                if (response.data.success || response.data.Success == "1" || (response.data.data && response.data.data.Success == "1")) {
                    alert(txt.deleteSuccess);
                    setSelectedUser(null);
                    fetchUsers();
                } else {
                    alert(response.data.message || response.data.Message || response.data.data?.Message || txt.deleteFailed);
                }
            } catch (error) {
                console.error("Delete Error:", error);
                alert(txt.deleteError);
            }
        }
    };

    const filteredUsers = (users || []).filter(user => {
        if (!searchTerm) return true;
        const lowerSearch = searchTerm.toLowerCase();
        return (
            (user.name && user.name.toLowerCase().includes(lowerSearch)) ||
            (user.mobile_no && user.mobile_no.includes(lowerSearch))
        );
    });

    if (loading) {
        return (
            <div className={`app-container p-4`}>
                <Header title={txt.title} />
                <div className="loader-wrapper">
                    <div className="spinner"></div>
                    <p className="loader-text">{txt.loading}</p>
                    <style jsx>{`
                        .app-container { background: #f8fafc; min-height: 100vh; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; }
                        .loader-wrapper { display: flex; flex-direction: column; justify-content: center; align-items: center; min-height: 60vh; width: 100%; }
                        .spinner { width: 50px; height: 50px; border: 4px solid #E5E7EB; border-top: 4px solid #2563EB; border-radius: 50%; animation: spin 1s linear infinite; margin-bottom: 16px; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1); }
                        .loader-text { color: #6B7280; font-weight: 500; font-size: 1.1rem; animation: pulse 1.5s ease-in-out infinite; }
                        @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
                        @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }
                    `}</style>
                </div>
            </div>
        );
    }

    return (
        <>
            {/* Add Volunteer Modal */}
            {isModalOpen && (
                <div className="modal-overlay">
                    <div className="modal-content-box" style={{ maxWidth: '400px', padding: '0px' }}>
                        <div className="modal-header">
                            <div><h2>{txt.addModalTitle}</h2></div>
                            <button className="close-btn-icon" onClick={() => { setIsModalOpen(false); setFormData({ name: '', mobile_no: '' }); setMobileError(""); }}>
                                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                            </button>
                        </div>
                        <form onSubmit={handleAddVolunteer}>
                            <div className="modal-body-grid" style={{ display: 'flex', flexDirection: 'column', gap: '15px', padding: '10px 0' }}>
                                <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                    <label style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>{txt.nameLabel}</label>
                                    <input type="text" name="name" value={formData.name} onChange={handleInputChange} className="form-input" style={{ padding: '10px 15px', borderRadius: '8px', border: '1px solid #d1d5db', outline: 'none' }} required />
                                </div>
                                <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                    <label style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>{txt.mobileLabel}</label>
                                    <input
                                        type="text"
                                        name="mobile_no"
                                        value={formData.mobile_no}
                                        onChange={handleInputChange}
                                        maxLength="10"
                                        className="form-input"
                                        style={{
                                            padding: '10px 15px',
                                            borderRadius: '8px',
                                            border: mobileError ? '1px solid #ef4444' : '1px solid #d1d5db',
                                            outline: 'none'
                                        }}
                                        required
                                    />
                                    {mobileError && (
                                        <div style={{ fontSize: '12px', color: '#ef4444', marginTop: '4px' }}>
                                            {mobileError}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '10px' }}>
                                <button type="button" className="btn-cancel" onClick={() => { setIsModalOpen(false); setFormData({ name: '', mobile_no: '' }); setMobileError(""); }} style={{ padding: '10px 20px', borderRadius: '8px', border: '1px solid #d1d5db', background: 'white', cursor: 'pointer' }}>{txt.cancelBtn}</button>
                                <button type="submit" className="btn-search-main" disabled={isSubmitting} style={{ padding: '10px 20px', borderRadius: '8px', border: 'none', background: '#2563eb', color: 'white', cursor: isSubmitting ? 'not-allowed' : 'pointer' }}>{isSubmitting ? txt.addingBtn : txt.submitBtn}</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Edit Volunteer Modal */}
            {isEditModalOpen && (
                <div className="modal-overlay">
                    <div className="modal-content-box" style={{ maxWidth: '400px', padding: '0px' }}>
                        <div className="modal-header">
                            <div><h2>{txt.editModalTitle}</h2></div>
                            <button className="close-btn-icon" onClick={() => setIsEditModalOpen(false)}>
                                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                            </button>
                        </div>
                        <form onSubmit={handleUpdateVolunteer}>
                            <div className="modal-body-grid" style={{ display: 'flex', flexDirection: 'column', gap: '15px', padding: '10px 0' }}>
                                <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                    <label style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>{txt.nameLabel}</label>
                                    <input type="text" name="name" value={editFormData.name} onChange={handleEditInputChange} className="form-input" style={{ padding: '10px 15px', borderRadius: '8px', border: '1px solid #d1d5db', outline: 'none' }} required />
                                </div>
                                <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                    <label style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>{txt.mobileLabel}</label>
                                    <input
                                        type="text"
                                        name="mobile_no"
                                        value={editFormData.mobile_no}
                                        onChange={handleEditInputChange}
                                        maxLength="10"
                                        className="form-input"
                                        style={{
                                            padding: '10px 15px',
                                            borderRadius: '8px',
                                            border: editMobileError ? '1px solid #ef4444' : '1px solid #d1d5db',
                                            outline: 'none'
                                        }}
                                        required
                                    />
                                    {editMobileError && (
                                        <div style={{ fontSize: '12px', color: '#ef4444', marginTop: '4px' }}>
                                            {editMobileError}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '10px' }}>
                                <button type="button" className="btn-cancel" onClick={() => setIsEditModalOpen(false)} style={{ padding: '10px 20px', borderRadius: '8px', border: '1px solid #d1d5db', background: 'white', cursor: 'pointer' }}>{txt.cancelBtn}</button>
                                <button type="submit" className="btn-search-main" disabled={isEditing} style={{ padding: '10px 20px', borderRadius: '8px', border: 'none', background: '#2563eb', color: 'white', cursor: isEditing ? 'not-allowed' : 'pointer' }}>{isEditing ? txt.updatingBtn : txt.updateBtn}</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Profile Detail Modal - Updated with photo upload */}
            {selectedUser && (
                <div className="modal-overlay" onClick={() => setSelectedUser(null)}>
                    <div className="profile-detail-container" onClick={(e) => e.stopPropagation()}>
                        <button className="profile-close-btn" onClick={() => setSelectedUser(null)}>
                            <svg width="24" height="24" fill="none" stroke="white" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                        </button>
                        <div className="profile-detail-card">
                            <div className="profile-avatar-wrapper">
                                <div className="profile-avatar-bg">
                                    <img
                                        src={selectedUser.photo_path || selectedUser.photo || `https://ui-avatars.com/api/?name=${encodeURIComponent(selectedUser.name)}&background=e5e5e5&color=a3a3a3`}
                                        alt={selectedUser.name}
                                    />
                                </div>
                            </div>
                            <div className="profile-content">
                                <h2 className="profile-name">{selectedUser.name}</h2>
                                <p className="profile-mobile" style={{ marginTop: '8px', marginBottom: '8px' }}>{selectedUser.mobile_no}</p>

                                {/* Status badge below mobile number in modal */}
                                <div style={{ marginBottom: '24px' }}>
                                    <span style={{
                                        display: 'inline-block',
                                        padding: '2px 10px',
                                        borderRadius: '12px',
                                        fontSize: '11px',
                                        fontWeight: 'bold',
                                        backgroundColor: (selectedUser.status === "0" || selectedUser.status === 0 || selectedUser.temp_status === false) ? '#fee2e2' : '#dcfce7',
                                        color: (selectedUser.status === "0" || selectedUser.status === 0 || selectedUser.temp_status === false) ? '#991b1b' : '#166534',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px'
                                    }}>
                                        {(selectedUser.status === "0" || selectedUser.status === 0 || selectedUser.temp_status === false) ? "Inactive" : "Active"}
                                    </span>
                                </div>

                                <div className="profile-big-btns">
                                    <a href={`https://wa.me/91${selectedUser.mobile_no}?text=${encodeURIComponent(generateWhatsAppMessage(selectedUser.name))}`} target="_blank" rel="noreferrer" className="btn-resp btn-wa">
                                        <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
                                        {txt.sendWhatsapp}
                                    </a>
                                    <a href={`sms:${selectedUser.mobile_no}?body=${encodeURIComponent(generateSMSMessage(selectedUser.name))}`} className="btn-resp btn-sms-big">
                                        <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2 2z"></path></svg>
                                        {txt.sendSMS}
                                    </a>
                                </div>
                            </div>
                            <div className="profile-bottom-bar">
                                <a href={`tel:${selectedUser.mobile_no}`} className="btm-icon-wrapper">
                                    <div className="icon-transparent" style={{ color: '#0ea5e9' }}>
                                        <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" /></svg>
                                    </div>
                                </a>
                                <div className="divider"></div>
                                <a href={`https://wa.me/91${selectedUser.mobile_no}`} target="_blank" rel="noreferrer" className="btm-icon-wrapper">
                                    <div className="icon-transparent" style={{ color: '#22c55e' }}>
                                        <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
                                    </div>
                                </a>
                                <div className="divider"></div>
                                <a href={`sms:${selectedUser.mobile_no}`} className="btm-icon-wrapper">
                                    <div className="icon-transparent" style={{ color: '#3b82f6', position: 'relative' }}>
                                        <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 10H6v-2h12v2zm0-3H6V7h12v2z" /></svg>
                                        <span style={{ position: 'absolute', fontSize: '7px', color: 'white', fontWeight: 'bold', marginTop: '-2px' }}></span>
                                    </div>
                                </a>
                                <div className="divider"></div>
                                <button className="btm-icon-wrapper" onClick={handleEditClick} style={{ background: 'none', border: 'none', padding: 0 }}>
                                    <div className="icon-transparent" style={{ color: '#f59e0b' }}>
                                        <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" /></svg>
                                    </div>
                                </button>
                                <div className="divider"></div>
                                <button className="btm-icon-wrapper" onClick={() => handleDeleteAdmin(selectedUser.user_id || selectedUser.id)} style={{ background: 'none', border: 'none', padding: 0 }}>
                                    <div className="icon-transparent" style={{ color: '#ef4444' }}>
                                        <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" /></svg>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className={`app-container p-4 ${isModalOpen || isEditModalOpen || selectedUser ? 'blur-background' : ''}`}>

                <Header title={txt.title} />

                <div className="filter-container mt-3">
                    <div className={`search-wrapper ${isMobileSearchOpen ? 'mobile-open' : ''}`}>
                        <svg className="search-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                        <input
                            type="text"
                            className="search-input"
                            placeholder={txt.searchPlaceholder}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <button className="close-search-btn" onClick={() => { setIsMobileSearchOpen(false); setSearchTerm(''); }}>
                            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                        </button>
                    </div>

                    <div className="action-group">
                        {!isMobileSearchOpen && (
                            <button className="mobile-search-trigger" onClick={() => setIsMobileSearchOpen(true)}>
                                <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                            </button>
                        )}
                        {/* --- Count Display --- */}
                        {!loading && (
                            <div className="count-display-modern slide-up-element">
                                <span className="count-label">Total :</span>
                                <span className="count-number">{filteredUsers.length}</span>
                            </div>
                        )}

                        <button className="btn-add-user" onClick={() => setIsModalOpen(true)}>
                            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                            </svg>
                            {txt.addBtn}
                        </button>
                    </div>
                </div>

                {/* 🔴 Premium User Card Grid - Same as AdminUsers */}
                <div className="user-grid">
                    {filteredUsers.length > 0 ? (
                        filteredUsers.map((user) => {
                            const isInactive = user.last_login === null || user.status === "0";
                            return (
                                <div key={user.id || user.user_id} className="modern-user-card" onClick={() => setSelectedUser(user)}>
                                    <div className="card-top-accent"></div>

                                    <div className="modern-card-avatar-wrapper">
                                        <div className="modern-card-avatar">
                                            <img
                                                src={user.photo_path || user.photo || `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name)}&background=eff6ff&color=2563eb&bold=true`}
                                                alt={user.name}
                                            />
                                        </div>
                                        <span className={`avatar-status-dot ${isInactive ? 'dot-inactive' : 'dot-active'}`}></span>
                                    </div>

                                    <h3 className="modern-card-name">{user.name}</h3>

                                    <span className={`status-pill ${isInactive ? 'pill-inactive' : 'pill-active'}`}>
                                        <span className="pill-dot"></span>
                                        {isInactive ? "Inactive" : "Active"}
                                    </span>

                                    <div className="modern-card-phone">
                                        <span className="phone-icon-circle">
                                            <svg width="12" height="12" fill="currentColor" viewBox="0 0 24 24">
                                                <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                            </svg>
                                        </span>
                                        {user.mobile_no}
                                    </div>

                                    <button className="modern-btn-view" onClick={(e) => { e.stopPropagation(); setSelectedUser(user); }}>
                                        <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                        </svg>
                                        {txt.viewProfile}
                                    </button>
                                </div>
                            );
                        })
                    ) : (
                        <div className="no-results" style={{ gridColumn: "1 / -1", textAlign: "center", padding: "40px", color: "#6b7280" }}>
                            {searchTerm ? `${txt.noRecordsFound} "${searchTerm}"` : "No volunteers found"}
                        </div>
                    )}
                </div>
            </div>

            <style jsx>{`
                /* --- PROFESSIONAL FILTER CONTAINER --- */
                .filter-container {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    gap: 16px;
                    margin-bottom: 24px;
                    background: transparent;
                }

                .action-group {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                }

                .mobile-search-trigger { display: none; }
                .close-search-btn { display: none; }

                .search-wrapper {
                    position: relative;
                    flex: 1;
                    max-width: 400px;
                }

                .search-icon {
                    position: absolute;
                    left: 14px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #94a3b8;
                    width: 20px;
                    height: 20px;
                }

                .search-input {
                    width: 100%;
                    padding: 12px 16px 12px 42px;
                    border: 1px solid #e2e8f0;
                    border-radius: 10px;
                    font-size: 14px;
                    color: #1e293b;
                    background-color: #ffffff;
                    outline: none;
                    transition: all 0.2s ease;
                    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
                }

                .search-input:focus {
                    border-color: #2563eb;
                    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
                }

                .btn-add-user {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    background-color: #2563eb;
                    color: #ffffff;
                    padding: 12px 20px;
                    border: none;
                    border-radius: 10px;
                    font-size: 14px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.2);
                    white-space: nowrap;
                }

                .btn-add-user:hover {
                    background-color: #1d4ed8;
                    transform: translateY(-1px);
                    box-shadow: 0 6px 8px -1px rgba(37, 99, 235, 0.3);
                }

                /* --- 🔴 POLISHED PREMIUM ADMIN CARD STYLES --- */
                .user-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
                    gap: 22px;
                    margin-top: 20px;
                }

                .modern-user-card {
                    background: #ffffff;
                    border-radius: 20px;
                    padding: 0 22px 24px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 14px -4px rgba(15, 23, 42, 0.08);
                    border: 1px solid #eef1f5;
                    transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);
                    position: relative;
                    cursor: pointer;
                    height: 100%;
                    overflow: hidden;
                }

                .modern-user-card:hover {
                    transform: translateY(-6px);
                    box-shadow: 0 22px 32px -12px rgba(37, 99, 235, 0.2), 0 4px 10px rgba(15, 23, 42, 0.05);
                    border-color: #dbeafe;
                }

                .card-top-accent {
                    width: calc(100% + 44px);
                    height: 68px;
                    background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 55%, #eef2ff 100%);
                    margin: 0 -22px -34px;
                    position: relative;
                    transition: opacity 0.3s ease;
                }

                .card-top-accent::after {
                    content: '';
                    position: absolute;
                    inset: 0;
                    background-image: radial-gradient(rgba(37,99,235,0.09) 1px, transparent 1px);
                    background-size: 12px 12px;
                }

                .modern-user-card:hover .card-top-accent {
                    opacity: 0.85;
                }

                .modern-card-avatar-wrapper {
                    position: relative;
                    z-index: 2;
                    margin-bottom: 16px;
                }

                .modern-card-avatar {
                    width: 88px;
                    height: 88px;
                    border-radius: 50%;
                    padding: 4px;
                    background: #ffffff;
                    box-shadow: 0 8px 20px -6px rgba(15, 23, 42, 0.18), 0 0 0 1px #eef1f5;
                    transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.35s ease;
                }

                .modern-user-card:hover .modern-card-avatar {
                    transform: scale(1.05);
                    box-shadow: 0 10px 24px -6px rgba(37, 99, 235, 0.3), 0 0 0 1px #dbeafe;
                }

                .modern-card-avatar img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    object-fit: cover;
                    border: none;
                }

                .avatar-status-dot {
                    position: absolute;
                    bottom: 5px;
                    right: 5px;
                    width: 15px;
                    height: 15px;
                    border-radius: 50%;
                    border: 3px solid #ffffff;
                    box-sizing: border-box;
                }

                .dot-active { background: #22c55e; box-shadow: 0 0 0 2px rgba(34,197,94,0.18); }
                .dot-inactive { background: #ef4444; box-shadow: 0 0 0 2px rgba(239,68,68,0.18); }

                .modern-card-name {
                    font-size: 1.08rem;
                    font-weight: 700;
                    color: #0f172a;
                    margin: 0 0 12px 0;
                    text-align: center;
                    letter-spacing: -0.2px;
                    max-width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .status-pill {
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    padding: 4px 13px;
                    border-radius: 20px;
                    font-size: 10.5px;
                    font-weight: 700;
                    text-transform: uppercase;
                    letter-spacing: 0.4px;
                    margin-bottom: 18px;
                }

                .pill-dot {
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                }

                .pill-active {
                    background: #ecfdf5;
                    color: #059669;
                    border: 1px solid #a7f3d0;
                }
                .pill-active .pill-dot { background: #10b981; box-shadow: 0 0 0 3px rgba(16,185,129,0.15); }

                .pill-inactive {
                    background: #fef2f2;
                    color: #dc2626;
                    border: 1px solid #fecaca;
                }
                .pill-inactive .pill-dot { background: #ef4444; box-shadow: 0 0 0 3px rgba(239,68,68,0.15); }

                .modern-card-phone {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    font-size: 0.85rem;
                    color: #475569;
                    background: #f8fafc;
                    padding: 6px 14px 6px 6px;
                    border-radius: 24px;
                    margin-bottom: 20px;
                    font-weight: 600;
                    border: 1px solid #eef1f5;
                    letter-spacing: 0.2px;
                    transition: all 0.25s ease;
                }

                .modern-user-card:hover .modern-card-phone {
                    background: #eff6ff;
                    border-color: #dbeafe;
                }

                .phone-icon-circle {
                    width: 22px;
                    height: 22px;
                    border-radius: 50%;
                    background: #dbeafe;
                    color: #2563eb;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                }

                .modern-btn-view {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                    padding: 12px;
                    background: #f1f5f9;
                    color: #2563eb;
                    border: 1px solid transparent;
                    border-radius: 12px;
                    font-weight: 700;
                    font-size: 0.85rem;
                    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
                    margin-top: auto;
                    letter-spacing: 0.2px;
                }

                .modern-btn-view:hover {
                    background: linear-gradient(135deg, #2563eb, #1d4ed8);
                    color: #ffffff;
                    box-shadow: 0 10px 18px -6px rgba(37, 99, 235, 0.45);
                    transform: translateY(-1px);
                }

                .modern-btn-view:active {
                    transform: translateY(0);
                }

                /* Mobile Optimization */
                @media (max-width: 640px) {
                    .filter-container { flex-direction: row; align-items: center; gap: 8px; }
                    .search-wrapper { display: block; flex: 1; max-width: none; }
                    .search-input { padding: 10px 16px 10px 36px; font-size: 13px; padding-right: 40px; }
                    .search-icon { left: 10px; width: 16px; height: 16px; }
                    .close-search-btn { display: block; position: absolute; right: 8px; top: 50%; transform: translateY(-50%); background: #f1f5f9; border: none; color: #64748b; padding: 4px; border-radius: 50%; cursor: pointer; display: flex; align-items: center; justify-content: center; z-index: 2; }
                    .action-group { width: auto; flex-shrink: 0; }
                    .btn-add-user { width: auto; padding: 10px 12px; font-size: 13px; gap: 4px; height: 46px; }
                    .btn-add-user svg { width: 16px; height: 16px; }
                    .mobile-search-trigger { display: none; }
                    .user-grid { grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); gap: 14px; }
                    .modern-user-card { padding: 0 14px 18px; border-radius: 16px; }
                    .modern-card-avatar { width: 72px; height: 72px; }
                    .modern-card-name { font-size: 0.95rem; }
                    .modern-card-phone { font-size: 0.75rem; padding: 4px 10px 4px 4px; }
                    .phone-icon-circle { width: 18px; height: 18px; }
                    .phone-icon-circle svg { width: 10px; height: 10px; }
                    .modern-btn-view { font-size: 0.75rem; padding: 10px; }
                    .status-pill { font-size: 9px; padding: 3px 10px; }
                    .card-top-accent { height: 50px; margin: 0 -14px -26px; width: calc(100% + 28px); }
                    .card-top-accent::after { background-size: 8px 8px; }
                    .avatar-status-dot { width: 12px; height: 12px; bottom: 3px; right: 3px; border-width: 2px; }
                }

                .blur-background { filter: blur(4px); pointer-events: none; }

                /* MODAL RESPONSIVE FIXES */
                .modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0.6); display: flex; align-items: center; justify-content: center; z-index: 1000; padding: 20px; box-sizing: border-box; }
                .modal-content-box { background: white; border-radius: 12px; width: 100%; box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1); padding: 24px; box-sizing: border-box; }
                .modal-header { display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #e5e7eb; padding: 15px; margin-bottom: 10px; }
                .modal-header h2 { margin: 0; font-size: 1.25rem; color: #111827; }
                .close-btn-icon { background: none; border: none; cursor: pointer; color: #6b7280; }
                .close-btn-icon:hover { color: #111827; }
                .profile-detail-container { position: relative; width: 100%; max-width: 380px; margin-top: 50px; }
                .profile-close-btn { position: absolute; top: -40px; right: -10px; background: none; border: none; cursor: pointer; padding: 5px; z-index: 10; }
                .profile-detail-card { background: white; border-radius: 20px; display: flex; flex-direction: column; overflow: visible; box-shadow: 0 15px 35px rgba(0,0,0,0.2); }
                .profile-avatar-wrapper { display: flex; justify-content: center; margin-top: -55px; }
                .profile-avatar-bg { width: 110px; height: 110px; background: white; border-radius: 50%; padding: 6px; cursor: pointer; position: relative; overflow: hidden; }
                .profile-avatar-bg img { width: 100%; height: 100%; border-radius: 50%; object-fit: cover; }
                .avatar-edit-overlay {
                    position: absolute;
                    top: 6px; left: 6px; right: 6px; bottom: 6px;
                    background: rgba(0,0,0,0.5);
                    display: flex; align-items: center; justify-content: center;
                    border-radius: 50%;
                    opacity: 0;
                    transition: opacity 0.2s ease;
                }
                .profile-avatar-bg:hover .avatar-edit-overlay {
                    opacity: 1;
                }
                .profile-content { padding: 15px 24px 25px 24px; text-align: center; }
                .profile-name { font-size: 22px; font-weight: 800; color: #111827; text-transform: uppercase; margin: 0; }
                .profile-mobile { font-size: 16px; color: #374151; letter-spacing: 0.5px; font-weight: 500; }
                .profile-big-btns { display: flex; flex-direction: column; gap: 12px; }
                .btn-resp { display: flex; align-items: center; justify-content: center; gap: 10px; width: 100%; padding: 14px; border-radius: 50px; color: white; font-weight: 600; text-decoration: none; font-size: 15px; transition: transform 0.2s, box-shadow 0.2s; border: none; box-sizing: border-box; }
                .btn-resp:hover { transform: translateY(-2px); box-shadow: 0 4px 10px rgba(0,0,0,0.15); color: white; }
                .btn-wa { background-color: #4ade80; } .btn-sms-big { background-color: #f59e0b; }
                .profile-bottom-bar { background-color: #213555; border-radius: 0 0 20px 20px; display: flex; justify-content: space-evenly; align-items: center; padding: 8px 0; }
                .divider { width: 1px; height: 24px; background-color: rgba(255, 255, 255, 0.3); }
                .btm-icon-wrapper { background: none; border: none; padding: 0; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: transform 0.2s; }
                .btm-icon-wrapper:hover { transform: scale(1.1); }

                /* --- COUNT DISPLAY --- */
                .count-display-modern {
                    display: inline-flex;
                    align-items: center;
                    background: #eff6ff;
                    padding: 8px 16px;
                    border-radius: 12px;
                    border: 1px solid #bfdbfe;
                    box-shadow: 0 2px 4px rgba(37, 99, 235, 0.05);
                    gap: 8px;
                }
                .count-label {
                    color: #1e40af;
                    font-weight: 600;
                    font-size: 15px;
                }
                .count-number {
                    background: transparent;
                    color: #1d4ed8;
                    font-weight: 800;
                    font-size: 16px;
                }
            `}</style>
        </>
    );
};

export default Volunteers;